/* WorkflowEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
// const { typeLabelsList, getTypeData, typeDataByLabel } = require("../CustomFieldsConstants");
const CommonEditor = require("./CommonEditor");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

class WorkflowEditor extends CommonEditor {
    constructor(args) {
        super(args);
        this.rootElement.classList.add("select");
        this.rootElement.classList.add("wf-editor");
        this._grid = args.grid;
        this._dropdownOptions = [];
        this._dropdownOptions.push({
            label: "None",
            value: ""
        });
        this._dropdownOptions = this._dropdownOptions.concat(Object.values(args.item.workflows).map(item => {
            return {
                label: item.name,
                value: item.id
            };
        }).sort((objA, objB) => {
            if (objA.label.toLowerCase() > objB.label.toLowerCase()) {
                return 1;
            }
            if (objA.label.toLowerCase() < objB.label.toLowerCase()) {
                return -1;
            }
            return 0;
        }));
        this.input.setOptions(this._dropdownOptions);
    }

    applyValue(item, state) {
        // console.log(item, state);
        super.applyValue(item, state);
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        const combobox = new SingleComboBoxControl({
            showFilter: false,
            darkTheme: false,
            adjustWidth: true,
            allowClear: false
        });
        // combobox.setOptions(this._dropdownOptions);
        return combobox;
    }
}

module.exports = WorkflowEditor;
